import {
  AspectRatio,
  Box,
  Button,
  Heading,
  HStack,
  Input,
  Link,
  Stack,
  Stat,
  StatHelpText,
  StatLabel,
  Text,
  useColorModeValue,
  VStack,
  Image,
  useToast,
  Spinner,
} from '@chakra-ui/react'

import { motion } from 'framer-motion'
import { useState } from 'react'
import { Web3Storage } from 'web3.storage'
import UploadSvg from '../assets/upload.svg'

const IPFSUploader = () => {
  const [file, setFile] = useState(null)
  const [uploading, setUploading] = useState(false)
  const toast = useToast()

  const handleChange = (event: any) => {
    setFile(event.target.files[0])
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    if (!file) {
      return
    }

    setUploading(true)

    const client = new Web3Storage({ token: process.env.REACT_APP_WEB3_STORAGE_API_KEY! })
    const cid = await client.put([file])
    const url = `https://dweb.link/ipfs/${cid}`

    toast({
      position: 'bottom-right',
      duration: 6000,
      render: () => (
        <Stat bgColor={'brand.50'} py={'3'} px={'8'} borderRadius={'lg'}>
          <StatLabel>File Upload Successfull</StatLabel>
          <StatHelpText>
            {url && (
              <Link href={url} target="_blank">
                View on IPFS
              </Link>
            )}
          </StatHelpText>
        </Stat>
      ),
    })
    setUploading(false)
  }

  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '60vh', md: '60vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
    >
      <HStack minH={{ base: '70vh', md: '67vh' }} wrap={'wrap'} align={'center'} justify={'center'}>
        <Image src={UploadSvg} boxSize={{ base: '220px', md: 'sm' }}></Image>
        <Stack
          spacing={4}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '6', md: '12' }}
          my={{ base: '6', md: '12' }}
        >
          <Heading fontSize={{ base: '2xl', md: '4xl' }} color={'brand.500'} alignSelf={'center'}>
            Web3 Cloud ☁️
          </Heading>
          <Text alignSelf={'center'}>Upload Files to IPFS</Text>

          <AspectRatio width="72" ratio={2}>
            <Box
              borderColor="gray.300"
              borderStyle="dashed"
              borderWidth="2px"
              rounded="md"
              shadow="sm"
              role="group"
              transition="all 150ms ease-in-out"
              _hover={{
                shadow: 'md',
              }}
              as={motion.div}
              initial="rest"
              animate="rest"
              whileHover="hover"
            >
              <Box position="relative" width="100%">
                <Stack p="4" textAlign="center" spacing="1">
                  <Heading fontSize="lg" color="gray.700" fontWeight="bold">
                    Drag and Drop
                  </Heading>
                  <Text fontWeight="light">or click to upload</Text>
                </Stack>
                <Input
                  type="file"
                  width="100%"
                  height={'32'}
                  position="absolute"
                  top="0"
                  left="0"
                  opacity="0"
                  aria-hidden="true"
                  accept="image/*"
                  onChange={handleChange}
                />
              </Box>
            </Box>
          </AspectRatio>
          {file && (
            <Stack>
              <Text>File Name: {file['name']}</Text>
            </Stack>
          )}
          <Stack spacing={6}>
            {file && (
              <Button
                bg={'brand.500'}
                color={'white'}
                _disabled={{
                  bg: 'gray.600',
                  cursor: 'not-allowed',
                }}
                _hover={{
                  bg: 'brand.600',
                }}
                onClick={handleSubmit}
                isDisabled={!file || uploading}
              >
                {uploading && <Spinner size="sm" thickness="2px" color="white" mx={'3px'} />}
                {uploading ? 'Uploading' : 'Upload'}
              </Button>
            )}
          </Stack>
        </Stack>
      </HStack>
    </VStack>
  )
}

export default IPFSUploader
